<app-header></app-header>
<div class="container-fluid">
  <mat-tab-group #tabs (selectedTabChange)="tabClick($event)">
    <!--Page 1 - Display all ontologies, search filter-->
    <mat-tab label="Ontology Table">
      <div fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign="space-between center" style="margin: 30px 0 10px 0;">
        <div>
          <h2 style="display: inline-block;">Livestock Ontologies</h2>
          <sup>
            <button mat-flat-button color="accent" class="beta-tag">Beta</button>
          </sup>
        </div>
        @if (!token) {
          <button mat-raised-button color="primary" (click)="openLoginModal()">Login</button>
        }
        @if (token) {
          <button mat-raised-button color="warn" (click)="logout()">Logout</button>
        }
      </div>
      <div class="row" fxLayout.lt-md="column" fxLayoutGap="2%" style="padding-top: 10px; padding-bottom: 10px;">
        <div fxFlex="17" fxFlex.lt-md="100">
          <app-filter title="Projects" [filterSize]=4></app-filter>
          <app-filter title="Ontology Type" [filterSize]=5></app-filter>
          <app-filter title="Term Status" [filterSize]=4></app-filter>
        </div>
        <div fxFlex="81" fxFlex.lt-md="100">
          @if (hasActiveFilters()) {
            <div>
              @if (hasActiveFilters()) {
                <app-active-filter style="margin-right: 10px;"></app-active-filter>
              }
              <button mat-raised-button (click)="removeFilter()">Remove all filters</button>
              <hr>
            </div>
          }

          @if (showSpinner) {
            <div style="padding: 15px">
              <mat-spinner [diameter]="30"></mat-spinner>
            </div>
          }

          <app-table-server-side #tableComp id="ontology-table"
                                 [display_fields]="displayFields"
                                 [column_names]="columnNames"
                                 [filter_values]="filter_field"
                                 [templates]="templates"
                                 [apiFunction]="loadTableDataFunction"
                                 [query]="query"
                                 [defaultSort]="defaultSort">
          </app-table-server-side>
        </div>
      </div>
    </mat-tab>
    <!--Page 2 - Ontology Improvment tool (Requires login) -->
    <mat-tab label="Check/Add missing terms">
      <!-- Validate ontologies (Only for Authenticated Users) -->
      @if (token) {
        <!--Page 2.1 - Input terms-->
        @if (mode == 'input' || mode == 'validate') {
          <div style="margin-bottom: 40px;">
            <div fxLayout="row" fxLayoutAlign="space-between center" style="margin-top: 30px; margin-bottom: 20px;">
              <h2>Check/Add missing terms</h2>
              <button mat-raised-button color="warn" (click)="logout()">Logout</button>
            </div>
            <p>Enter Ontology terms in the text box below. For batch input, enter one term per line.</p>
            <textarea class="ontology-input" [(ngModel)]="ontologyTerms"></textarea>
            <button mat-flat-button color="primary" (click)="searchTerms()">Search</button>
          </div>
        }
        <!--Page 2.2 - Display existing terms-->
        @if ((searchResults | json) != '{}' && mode == 'validate') {
          <div style="margin-bottom: 40px;">
            <h4>Existing terms</h4>
            @if (searchResults.found?.length) {
              <app-table-server-side id="results-table"
                                     [display_fields]="displayFields"
                                     [column_names]="columnNames"
                                     [filter_values]="searchResults.filter"
                                     [templates]="templates"
                                     [apiFunction]="loadTableDataFunction"
                                     [query]="searchResults.query"
                                     [defaultSort]="defaultSort">
              </app-table-server-side>
            }
            @if (searchResults.found?.length == 0) {
              No terms found
            }
          </div>
        }
        <!--Page 2.3 - Display Ontology Matches for new terms-->
        @if ((ontologyMatches | json) != '{}' && mode == 'validate') {
          <div style="margin-bottom: 40px;">
            <h4>Ontology Matches for new terms</h4>
            <p>Select the best match for each your ontology terms</p>
            <br>
            <mat-accordion>
              @for (item of ontologyMatches | keyvalue; track item; let isFirst = $first) {
                <mat-expansion-panel
                  [expanded]="selectedTerm.key ? item.key === selectedTerm.key : isFirst"
                  (opened)="panelOpenState = true" (closed)="panelOpenState = false"
                  style="margin-bottom: 20px;">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <h6><b>Ontology Matches for term '{{ item.key }}'</b></h6>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  @if (getArrLength(item['value'])) {
                    <table mat-table [dataSource]="getItemValueArray(item)" table-striped style="width: 100%">
                      @for (col of ontologyMatchColsToDisplay; track col; let i = $index) {
                        @if (col == 'source') {
                          <ng-container [matColumnDef]=col>
                            <th mat-header-cell class="table-header"
                                *matHeaderCellDef> {{ ontologyMatchTableHeaders[i] }}
                            </th>
                            <td mat-cell class="table-cell-data" *matCellDef="let data; let j = index">
                              {{ data[col] }}
                              @if (!data['selected']) {
                                <input type="checkbox" [(ngModel)]="data['selected']"
                                       (click)="addNewOntology(getItemKey(item), j)"
                                       style="margin-right: 40px; float: right;" [disabled]="disableOntologyCreation">
                              }
                              @if (data['selected']) {
                                <button mat-raised-button color="primary"
                                        (click)="editNewOntology(getItemKey(item), j)"
                                        style="margin-right: 20px; padding: 2px 10px 2px 10px; float: right;"
                                        [disabled]="disableOntologyCreation"> Edit
                                </button>
                              }
                            </td>
                          </ng-container>
                        }
                        @if (col != 'source') {
                          <ng-container [matColumnDef]=col>
                            <th mat-header-cell class="table-header"
                                *matHeaderCellDef> {{ ontologyMatchTableHeaders[i] }}
                            </th>
                            <td mat-cell class="table-cell-data" *matCellDef="let data"> {{ data[col] }}</td>
                          </ng-container>
                        }
                      }
                      <tr mat-header-row *matHeaderRowDef="ontologyMatchColsToDisplay"></tr>
                      <tr mat-row *matRowDef="let row; columns: ontologyMatchColsToDisplay;"></tr>
                    </table>
                  }
                  @if (getArrLength(item['value']) == 0) {
                    <div fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign="space-between center">
                      <span>No Matches Found</span>
                      <button mat-raised-button color="primary" (click)="addNewOntology(getItemKey(item), -1)">Provide
                        Ontology
                      </button>
                    </div>
                  }
                </mat-expansion-panel>
              }
            </mat-accordion>
            <br>
            <button mat-raised-button color="primary" [disabled]="disableOntologyCreation" (click)="submitTerms()">
              Submit
            </button>
          </div>
        }
      }
    </mat-tab>
    <!-- Page 3 - Display Ontology usage statistics summary for each project -->
    <mat-tab label="Summary Statistics">
      @if (usageStats; as summary; ) {
        <div style="margin: 30px 0 10px 15px;">
          <app-table-client-side
            [display_fields]="statsFields"
            [column_names]="statsColumns"
            [templates]="templates"
            [data]="summary"
            [page_size]=10>
          </app-table-client-side>
        </div>
      }
    </mat-tab>
  </mat-tab-group>
</div>

<!--
********************
Dialog box templates
********************
-->

<!-- Template: Login Modal Dialog Box -->
<ng-template #loginModalTemplate let-data>
  <!-- User Login -->
  @if (!registerUser) {
    <div mat-dialog-content>
      <h3><p>Login</p></h3>
      <mat-form-field appearance="fill" style="width: 100%">
        <mat-label>Enter your username</mat-label>
        <input matInput [(ngModel)]="username" autofocus>
      </mat-form-field>
      <br>
      <mat-form-field appearance="fill" style="width: 100%">
        <mat-label>Enter your password</mat-label>
        <input matInput [(ngModel)]="password" [type]="hide ? 'password' : 'text'">
        <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
                [attr.aria-pressed]="hide">
          <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
      </mat-form-field>
      @if (error) {
        <p class="alert alert-danger">{{ error }}</p>
      }
      <div fxLayout="row" fxLayoutAlign="space-between center" style="margin-top: 10px;">
        <button mat-raised-button color="primary" (click)="login()">
          Submit
        </button>
        <p> If you do not have an account, click
          <a href="" (click)="$event.preventDefault(); registerUser = !registerUser; error = '';">here</a>
          to register
          <br>
          Forgot password? Click <a href="https://aai.ebi.ac.uk/forgotPassword" target="_blank">here</a> to reset
        </p>
      </div>
    </div>
  }
  <!-- Register New User -->
  @if (registerUser) {
    <div mat-dialog-content>
      <h3><p>Register</p></h3>
      <form [formGroup]="regForm" novalidate>
        <!-- Username -->
        <div fxLayout="row">
          <div fxFlex="100" class="form-group">
            <label>Username</label>
            <input class="form-control" formControlName="username" type="text" required>
          </div>
        </div>
        @if (regForm.controls['username'].invalid && (regForm.controls['username'].dirty || regForm.controls['username'].touched)) {
          <div
            class="alert alert-danger">
            @if (regForm.controls['username'].errors?.['required']) {
              <div>
                Username is required
              </div>
            }
          </div>
        }
        <!-- Name -->
        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="4%" fxLayoutAlign="space-between">
          <!-- First Name -->
          <div fxFlex="48" class="form-group">
            <label>First Name</label>
            <input class="form-control" formControlName="first_name" type="text" required>
          </div>
          <!-- Last Name -->
          <div fxFlex="48" class="form-group">
            <label>Last Name</label>
            <input class="form-control" formControlName="last_name" type="text">
          </div>
        </div>
        @if (regForm.controls['first_name'].invalid && (regForm.controls['first_name'].dirty || regForm.controls['first_name'].touched)) {
          <div
            class="alert alert-danger">
            @if (regForm.controls['first_name'].errors?.['required']) {
              <div>
                First Name is required
              </div>
            }
          </div>
        }
        <!-- Email -->
        <div fxLayout="row">
          <div fxFlex="100" class="form-group">
            <label>Email</label>
            <input class="form-control" formControlName="email" type="email" required>
          </div>
        </div>
        @if (regForm.controls['email'].invalid && (regForm.controls['email'].dirty || regForm.controls['email'].touched)) {
          <div
            class="alert alert-danger">
            @if (regForm.controls['email'].errors?.['required']) {
              <div>
                Email is required
              </div>
            }
            @if (regForm.controls['email'].errors?.['email']) {
              <div>
                Enter valid email
              </div>
            }
          </div>
        }
        <!-- Passwords -->
        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="4%" fxLayoutAlign="space-between">
          <div fxFlex="48" class="form-group">
            <label>Password</label>
            <input class="form-control" formControlName="password" type="password" required>
          </div>
          <div fxFlex="48" class="form-group">
            <label>Confirm Password</label>
            <input class="form-control" formControlName="confirmPwd" type="password" required>
          </div>
        </div>
        @if (regForm.controls['password'].invalid && (regForm.controls['password'].dirty || regForm.controls['password'].touched)) {
          <div
            class="alert alert-danger">
            @if (regForm.controls['password'].errors?.['required']) {
              <div>
                Password is required
              </div>
            }
          </div>
        }
        @if (regForm.controls['confirmPwd'].invalid && (regForm.controls['confirmPwd'].dirty || regForm.controls['confirmPwd'].touched)) {
          <div
            class="alert alert-danger">
            @if (regForm.controls['confirmPwd'].errors?.['required']) {
              <div>
                Password confirmation is required
              </div>
            }
            @if (regForm.controls['confirmPwd'].errors?.['NotEqual']) {
              <div>
                Password do not match
              </div>
            }
          </div>
        }
        <!-- Organisation -->
        <div fxLayout="row">
          <div fxFlex="100" class="form-group">
            <label>Organisation</label>
            <input class="form-control" formControlName="organisation" type="text" required>
          </div>
        </div>
        @if (regForm.controls['organisation'].invalid && (regForm.controls['organisation'].dirty || regForm.controls['organisation'].touched)) {
          <div
            class="alert alert-danger">
            @if (regForm.controls['organisation'].errors?.['required']) {
              <div>
                Organisation is required.
              </div>
            }
          </div>
        }
        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between" style="margin-top: 20px;">
          <button mat-raised-button color="primary" type="submit" (click)=register()
                  [disabled]="regForm.pristine || regForm.invalid">
            Submit
          </button>
          <button mat-raised-button color="accent" (click)="registerUser = !registerUser">
            Back to Login
          </button>
        </div>
      </form>
      <br>
      @if (error) {
        <p class="alert alert-danger">{{ error }}</p>
      }
    </div>
  }
</ng-template>

<!-- Template: Dialog Box - select project for validation -->
<ng-template #selectProjectModalTemplate let-data>
  <div mat-dialog-content fxLayout="column" style="height: 100%">
    <div fxFlex="75">
      <p>Select project(s) (if any) for which the ontology is being validated</p>
      <mat-form-field appearance="fill" style="width: 100%;">
        <mat-label>Project</mat-label>
        <mat-select [(ngModel)]="data.project" multiple>
          <mat-option value="AQUA-FAANG">AQUA-FAANG</mat-option>
          <mat-option value="BovReg">BovReg</mat-option>
          <mat-option value="GENE-SWitCH">GENE-SWitCH</mat-option>
          <mat-option value="HoloRuminent">HoloRuminent</mat-option>
          <mat-option value="GEroNIMO">GEroNIMO</mat-option>
          <mat-option value="RUMIGEN">RUMIGEN</mat-option>
          <mat-option value="EFFICACE">EFFICACE</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    @if (!showSpinner) {
      <div fxFlex="25">
        <button mat-raised-button color="warn" (click)="closeModal()"
                style="float:right; margin: 10px;">Cancel
        </button>
        @if (data.status == 'Verified') {
          <button mat-raised-button color="primary"
                  (click)="validateOntology(data.ontology, data.project, data.status)"
                  style="float:right; margin: 10px;" cdkFocusInitial>Submit
          </button>
        }
        @if (data.status == 'Needs Improvement') {
          <button mat-raised-button color="primary"
                  (click)="validateOntology(data.ontology, data.project, data.status)"
                  style="float:right; margin: 10px;" cdkFocusInitial>Next
          </button>
        }
      </div>
    }
    @if (showSpinner) {
      <div fxFlex="30">
        <mat-spinner [diameter]="30"></mat-spinner>
      </div>
    }
  </div>
</ng-template>

<!-- Template: Dialog Box - suggest changes -->
<ng-template #validateModalTemplate let-data>
  <div mat-dialog-content>
    <mat-form-field appearance="fill" style="width: 100%;">
      <mat-label>Ontology Text</mat-label>
      <input matInput [(ngModel)]="data.ontology.term">
    </mat-form-field>

    <mat-form-field appearance="fill" style="width: 100%;">
      <mat-label>Comments</mat-label>
      <textarea [(ngModel)]="userComments" matInput
                placeholder="Please provide any feedback that may be useful to other users. This is an optional field"></textarea>
    </mat-form-field>
  </div>
  @if (!showSpinner) {
    <div>
      <button mat-raised-button color="warn" (click)="closeModal()"
              style="float:right; margin: 10px;">Cancel
      </button>
      <button mat-raised-button color="primary"
              (click)="submitFeedback(data.ontology, data.project, data.status, userComments)"
              style="float:right; margin: 10px;" cdkFocusInitial>Submit
      </button>
    </div>
  }
  @if (showSpinner) {
    <div>
      <mat-spinner [diameter]="30"></mat-spinner>
    </div>
  }
</ng-template>

<!-- Template: Dialog Box - Edit existing Ontologies -->
<ng-template #editModalTemplate let-data>
  <div mat-dialog-content>
    <mat-form-field appearance="fill" style="width: 100%;">
      <mat-label>Ontology Type</mat-label>
      <mat-select [(ngModel)]="data.type" multiple>
        @for (type of types; track type) {
          <mat-option [value]="type">
            {{ type }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="fill" style="width: 100%;">
      <mat-label>Project</mat-label>
      <mat-select [(ngModel)]="data.projects" multiple>
        <mat-option value="AQUA-FAANG">AQUA-FAANG</mat-option>
        <mat-option value="BovReg">BovReg</mat-option>
        <mat-option value="GENE-SWitCH">GENE-SWitCH</mat-option>
        <mat-option value="HoloRuminent">HoloRuminent</mat-option>
        <mat-option value="GEroNIMO">GEroNIMO</mat-option>
        <mat-option value="RUMIGEN">RUMIGEN</mat-option>
        <mat-option value="EFFICACE">EFFICACE</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="fill" style="width: 100%;">
      <mat-label>Species</mat-label>
      <mat-select [(ngModel)]="data.species" multiple>
        @for (spc of species; track spc) {
          <mat-option [value]="spc">
            {{ spc }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="fill" style="width: 100%;">
      <mat-label>Summary</mat-label>
      <textarea matInput [(ngModel)]="data.summary"
                cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1">
                  </textarea>
    </mat-form-field>
    Synonyms: (Type and press enter to add another synonym)
    <br>
    @for (synonym of data.synonyms; track synonym; let i = $index) {
      <div>
        @if (synonym.length) {
          <button mat-button class="tags"
                  (click)="editTag(data, synonym, 'synonyms')">
            {{ synonym }}
            <mat-icon>edit</mat-icon>
          </button>
        }
        <mat-icon (click)="removeTag(data, synonym, 'synonyms')"
                  style="vertical-align: middle;">close
        </mat-icon>
      </div>
    }
    <mat-form-field appearance="fill" style="width: 100%;">
      <input matInput
             [(ngModel)]="newTag['synonyms']"
             (keyup.enter)="addNewTag(newTag['synonyms'], 'synonyms')"
             placeholder="Add more synonyms">
    </mat-form-field>
    Tags: (Type and press enter to add another tag)
    <br>
    @for (tag of data.tags; track tag; let i = $index) {
      <div>
        @if (tag.length) {
          <button mat-button class="tags"
                  (click)="editTag(data, tag, 'tags')">
            {{ tag }}
            <mat-icon>edit</mat-icon>
          </button>
        }
        <mat-icon (click)="removeTag(data, tag, 'tags')"
                  style="vertical-align: middle;">close
        </mat-icon>
      </div>
    }
    <mat-form-field appearance="fill" style="width: 100%;">
      <input matInput
             [(ngModel)]="newTag['tags']"
             (keyup.enter)="addNewTag(newTag['tags'], 'tags')"
             placeholder="Add more tags">
    </mat-form-field>
  </div>
  @if (!showSpinner) {
    <div>
      <button mat-raised-button color="warn" (click)="closeModal()"
              style="float:right; margin: 10px;">Cancel
      </button>
      <button mat-raised-button color="primary" (click)="submitEditedOntology(data)"
              style="float:right; margin: 10px;" cdkFocusInitial>Submit
      </button>
    </div>
  }
  @if (showSpinner) {
    <div>
      <mat-spinner [diameter]="30"></mat-spinner>
    </div>
  }
</ng-template>

<!-- Template: Dialog Box - Show status activity history -->
<ng-template #activityModalTemplate let-data>
  <div mat-dialog-content>
    <h3>Status Activity History</h3>
    @for (action of data; track action) {
      <div style="margin-bottom: 10px;">
        <div style="font-size: 14px; color: #4d759a;">
          {{ action.timestamp.replace('T', ' ').replace('+', ' +').split('.')[0] }}
        </div>
        <div>{{ generateStatusMsg(action) }}</div>
        @if (action.comments) {
          <div>
            {{ action.user }} provided the following feedback: <span class="userComments">{{ action.comments }}</span>
          </div>
        }
      </div>
    }
  </div>
</ng-template>

<!-- Template: Dialog Box - Adding new ontologies from Zooma -->
<ng-template #modalTemplate let-data>
  <div mat-dialog-content>
    <ng-container>
      <mat-form-field appearance="fill" style="width: 100%;">
        <mat-label>Proposed Ontology Type</mat-label>
        <mat-select [(ngModel)]="data.term_type" multiple>
          @for (type of types; track type) {
            <mat-option [value]="type">
              {{ type }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="fill" style="width: 100%;">
        <mat-label>Proposed Ontology ID</mat-label>
        @if (ontologyIdOptions.length == 0) {
          <input matInput [(ngModel)]="data.ontology_id">
        }
        @if (ontologyIdOptions.length) {
          <mat-select [(ngModel)]="data.ontology_id" multiple>
            @for (id of ontologyIdOptions; track id) {
              <mat-option [value]="id">
                {{ id }}
              </mat-option>
            }
          </mat-select>
        }
      </mat-form-field>
      <mat-form-field appearance="fill" style="width: 100%;">
        <mat-label>Proposed Ontology Text</mat-label>
        <input matInput [(ngModel)]="data.ontology_label">
      </mat-form-field>
    </ng-container>
    <mat-form-field appearance="fill" style="width: 100%;">
      <mat-label>Project</mat-label>
      <mat-select [(ngModel)]="data.project" multiple>
        <mat-option value="AQUA-FAANG">AQUA-FAANG</mat-option>
        <mat-option value="BovReg">BovReg</mat-option>
        <mat-option value="GENE-SWitCH">GENE-SWitCH</mat-option>
        <mat-option value="HoloRuminent">HoloRuminent</mat-option>
        <mat-option value="GEroNIMO">GEroNIMO</mat-option>
        <mat-option value="RUMIGEN">RUMIGEN</mat-option>
        <mat-option value="EFFICACE">EFFICACE</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="fill" style="width: 100%;">
      <mat-label>Species</mat-label>
      <mat-select multiple>
        @for (spc of species; track spc) {
          <mat-option [value]="spc">
            {{ spc }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="fill" style="width: 100%;">
      <mat-label>Summary</mat-label>
      <textarea matInput [(ngModel)]="data.summary"
                cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1">
                      </textarea>
    </mat-form-field>
    Synonyms: (Type and press enter to add another synonym)
    <br>
    @for (synonym of data.synonyms; track synonym; let i = $index) {
      <div>
        @if (synonym.length) {
          <button mat-button class="tags"
                  (click)="editTag(data, synonym, 'synonyms')">
            {{ synonym }}
            <mat-icon>edit</mat-icon>
          </button>
        }
        <mat-icon (click)="removeTag(data, synonym, 'synonyms')"
                  style="vertical-align: middle;">close
        </mat-icon>
      </div>
    }
    <mat-form-field appearance="fill" style="width: 100%;">
      <input matInput
             [(ngModel)]="newTag['synonyms']"
             (keyup.enter)="addTagToolTab(data, newTag['synonyms'], 'synonyms')"
             placeholder="Add more synonyms">
    </mat-form-field>
    Tags: (Type and press enter to add another tag)
    <br>
    @for (tag of data.tags; track tag; let i = $index) {
      <div>
        @if (tag.length) {
          <button mat-button class="tags"
                  (click)="editTag(data, tag, 'tags')">
            {{ tag }}
            <mat-icon>edit</mat-icon>
          </button>
        }
        <mat-icon (click)="removeTag(data, tag, 'tags')"
                  style="vertical-align: middle;">close
        </mat-icon>
      </div>
    }
    <mat-form-field appearance="fill" style="width: 100%;">
      <input matInput
             [(ngModel)]="newTag['tags']"
             (keyup.enter)="addTagToolTab(data, newTag['tags'], 'tags')"
             placeholder="Add more tags">
    </mat-form-field>
  </div>
  <div>
    <button mat-flat-button color="warn" (click)="closeModal()"
            style="float:right; margin: 10px;">Cancel
    </button>
    <button mat-flat-button color="primary" (click)="saveModalData(data)" [disabled]="disableOntologyCreation"
            style="float:right; margin: 10px;" cdkFocusInitial>Save
    </button>
  </div>
</ng-template>

<!--
**********************
Table column templates
**********************
-->

<!-- Template: Ontology table term column -->
<ng-template #ontologyTermTemplate let-item>
                      <span>
                        <a style="cursor: pointer" [routerLink]="item.term + '-' + item.id">
                          {{ item.term }}
                        </a>
                      </span>
</ng-template>

<!-- Template: Ontology table type column -->
<ng-template #ontologyTypeTemplate let-item>
  <span>{{ item.type.join(', ') }}</span>
</ng-template>

<!-- Template: Ontology table project column -->
<ng-template #ontologyProjectTemplate let-item>
  <span>{{ item.projects.join(', ') }}</span>
</ng-template>

<!-- Template: Ontology table tags column -->
<ng-template #ontologyTagsTemplate let-item>
  <span>{{ item.tags.join(', ') }}</span>
</ng-template>

<!-- Template: Ontology table status column -->
<ng-template #ontologyVotesTemplate let-item>
  <div fxLayout="row" fxFlexFill fxLayout.lt-sm="column" fxLayoutAlign="center center">
    <button mat-icon-button [disabled]="!token"
            (click)="startOntologyValidation(item, 'Verified')">
      <mat-icon>thumb_up</mat-icon>
    </button>
    <span>{{ item.upvotes_count }}</span>

    <button mat-icon-button [disabled]="!token"
            (click)="startOntologyValidation(item, 'Needs Improvement')">
      <mat-icon>thumb_down</mat-icon>
    </button>
    <span>{{ item.downvotes_count }}</span>

    <button mat-icon-button (click)="displayStatusActivity(item.status_activity)">
      <mat-icon>info_outline</mat-icon>
    </button>

    @if (token) {
      <button mat-button class="edit-button"
              style="margin-left: 15px; color: rgba(0, 0, 128, 0.8);"
              (click)="editOntology(item)">
        <div style="display: flex; align-items: center; gap: 3px;">
          <mat-icon>edit_outline</mat-icon>
          <div>Edit</div>
        </div>
      </button>
    }

  </div>
</ng-template>

<!-- Template: Usage stats table ontology types count column -->
<ng-template #typeCountTemplate let-item>
  @for (item of item.row.type_counts; track item) {
    <div>
      {{ item.type }}: {{ item.count }}
    </div>
  }
</ng-template>

<!-- Template: Usage stats table status count column -->
<ng-template #activityTemplate let-item>
  <div>
    <span [matBadge]="item.row.activity.created_edited_count">
      <button mat-stroked-button class="table-color-status"
              (click)="item['row']['activity']['created_edited_count'] ? onBadgeClick(item, 'all') : ''">
        Created/Updated
      </button>
    </span>
  </div>
  <div>
    <span [matBadge]="item.row.activity.validated_count">
      <button mat-stroked-button class="table-color-status"
              (click)="item['row']['activity']['validated_count'] ? onBadgeClick(item, 'validated') : ''">
        Validated
      </button>
    </span>
  </div>
  <div>
    <span [matBadge]="item.row.activity.downvoted_count">
      <button mat-stroked-button class="table-color-status"
              (click)="item['row']['activity']['downvoted_count'] ? onBadgeClick(item, 'downvoted') : ''">
        Needs improvement
      </button>
    </span>
  </div>
</ng-template>
